import { render } from "./TheProfessionalGeneralAuthorizations.vue?vue&type=template&id=77b4d796&scoped=true&ts=true"
import script from "./TheProfessionalGeneralAuthorizations.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalGeneralAuthorizations.vue?vue&type=script&lang=ts"

import "./TheProfessionalGeneralAuthorizations.vue?vue&type=style&index=0&id=77b4d796&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b4d796"]])

export default __exports__